export const AdminID = "qMbiDYDaWZOYY3rBWjFgcUvJoX22"
var date = new Date(), year = date.getFullYear(), month = date.getMonth();
export const firstDay = new Date(year, month, 1);
export const lastDay = new Date(year, month + 1, 0);
